import { Component, OnInit, Output, Input, AfterViewInit, EventEmitter } from '@angular/core';

import { DropdownValue } from '../shared/dropdown.model';

@Component({
    selector: 'page-size-selection',
    template: `<dropdown [values]="pageSizeValues" [selectedItem]="defaultPageSizeSelection" (valueChange)="onPageSizeValueChanged($event)" [useLightClass]="useLightClass"></dropdown>`
})
export class PageSizeSelectionComponent implements OnInit, AfterViewInit {
    pageSizeValues: Array<DropdownValue> = [];

    defaultPageSizeSelection: DropdownValue;

    @Input()
    useLightClass: boolean = false;

    @Output()
    public pageSizeChanged: EventEmitter<DropdownValue> = new EventEmitter<DropdownValue>();;

    constructor() {
    }

    ngOnInit() {
        this.pageSizeValues.push(new DropdownValue(25, '25 per page'));
        this.pageSizeValues.push(new DropdownValue(50, '50 per page'));
        this.pageSizeValues.push(new DropdownValue(75, '75 per page'));
        this.pageSizeValues.push(new DropdownValue(100, '100 per page'));
        this.defaultPageSizeSelection = this.pageSizeValues[0];
    }

    ngAfterViewInit() {
        this.defaultPageSizeSelection = this.pageSizeValues[0];
    }

    onPageSizeValueChanged(item: DropdownValue) {
        this.pageSizeChanged.emit(item);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/page-size-selection.component.ts